import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { STATS } from "@/data/content";
import { Reveal, EASE } from "./Reveal";

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-10% 0px" });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const c = animate(0, value, { duration: 1.8, ease: EASE, onUpdate: (v) => setN(v) });
    return () => c.stop();
  }, [inView, value]);
  const shown = Number.isInteger(value) ? Math.round(n) : n.toFixed(1);
  return (
    <span ref={ref} className="tabular-nums">
      {shown}
      <span className="text-brand-cyan">{suffix}</span>
    </span>
  );
};

export const Stats = () => (
  <section data-testid="stats-section" className="border-t border-white/10 bg-brand-slate py-20 text-white lg:py-28">
    <div className="mx-auto grid max-w-[1400px] gap-12 px-6 sm:grid-cols-2 lg:grid-cols-4 lg:px-10">
      {STATS.map((s, i) => (
        <Reveal key={s.label} delay={0.08 * i} data-testid={`stat-${i + 1}`} className="border-l border-white/10 pl-6">
          <div className="font-display text-5xl font-extrabold tracking-tight lg:text-6xl">
            <Counter value={s.value} suffix={s.suffix} />
          </div>
          <p className="mt-4 max-w-[220px] text-sm leading-relaxed text-white/55">{s.label}</p>
        </Reveal>
      ))}
    </div>
  </section>
);
